import React from "react";
import s from "./Card.module.scss";
import { formatNumber } from "../../../../../../libs/api/userSession";
type CardProp = {
  label: string;
  stat: number;
  onClick?:()=>void
};
function Card({ label, stat,onClick }: CardProp) {
  return (
    <div onClick={onClick} className={s.wrapper}>
      <h3 className={s.label}>{label}</h3>
      <h4 className={s.stat}> {formatNumber(stat)}</h4>
    </div>
  );
}

export default Card;
